/* @ngInject */
const saleLabels = ($filter) => {
  const self = {}

  self.fields = {
    id: {
      text: 'Id',
      messages: {

      },
    },
    number: {
      text: 'Numéro de la vente',
      messages: {
        exists: 'Ce numéro de vente existe déjà',
      },
    },
    owner: {
      text: 'Propriétaire',
      messages: {

      },
    },
    ownerId: {
      text: 'Id du propriétaire',
      messages: {

      },
    },
    date: {
      text: 'Date',
      messages: {

      },
    },
    axletreeDefaultWeight: {
      text: 'Poids par défaut des essieux',
    },
    dateBegin: {
      text: 'Le',
      messages: {

      },
    },
    dateEnd: {
      text: 'Jusqu\'au',
      messages: {

      },
    },

    axletrees: (_length) => {
      return _length + (_length > 1 ? ' essieux ' : ' essieu ') + 'dans cette vente'
    },
    pieces: (_length) => {
      return _length + (_length > 1 ? ' pièces ' : ' pièce ') + 'dans cette vente'
    },
    steriles: (_length) => {
      return _length + (_length > 1 ? ' stériles ' : ' stérile ') + 'dans cette vente'
    },
  }

  self.statements = {
    list: 'Liste des ventes',
    linkedWagons: 'Wagons liés à la vente',
    edit: 'Modification de la vente',
    display: (_sale) => {
      if (_sale) {
        _sale.date = $filter('field')(_sale.date, 'date')
        return 'Vente N°' + _sale.number + ' du ' + _sale.date + (_sale.owner ? ', ' + _sale.owner : '')
      }
      return 'Pas de vente'
    },
    addAxletrees: 'Ajouter des essieux',
    addPieces: 'Ajouter des pièces',
    addSteriles: 'Ajouter des stériles',
    selectWagons: 'Sélectionner les wagons à ajouter à la vente',
    generateAxletreesCertificate: 'Générer le relevé d\'essieux',
  }

  self.titles = {
    consult: 'Consulter les ventes',
    create: 'Créer une nouvelle vente',
    search: 'Rechercher des ventes',
  }

  self.log = {
    search: {
      success: (_length) => {
        if (_length === 0) {
          return 'Aucune vente ne correspond à la recherche.'
        } else if (_length === 1) {
          return '1 vente a été trouvée.'
        } else if (_length > 1) {
          return _length + ' ventes ont été trouvées.'
        }
        return 'Vente recherchée.'
      },
      failure: 'Aucune vente ne correspond à la recherche.',
      noResultWithId: 'Aucune vente ne correspond à cet identifiant',
    },
    save: {
      success: 'La vente a bien été créée.',
      failure: 'Une erreur est survenue lors de la création de la vente.',
    },
    update: {
      success: 'La vente a bien été éditée.',
      failure: 'Une erreur est survenue lors de la modification de la vente.',
    },
  }

  self.ask = {
    delete: 'Êtes-vous sûr de vouloir supprimer cette vente ? Tous les essieux, les pièces et les stériles qui lui sont associés seront supprimés en même temps.',
  }

  return self
}
export default saleLabels



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/scrapping/sale/resources/labels.resource.js